<template>
    <v-client-table class="dataTables_wrapper dashboard-table" :data="transactions" :columns="columns" :options="clientTableOptions">
        <d-col slot="affiliate_network_name" slot-scope="props" size="small" class="icon">
            <d-col class="rounded-circle" :style="{backgroundColor: props.row.network_background_color}">
                <span class="letter-icon">
                    {{ props.row.network_name | firstLettersLimit }}
                </span>
            </d-col>
        </d-col>
        <span slot="amount" slot-scope="props">
            EUR {{ props.row.amount | toDec }}
        </span>
        <d-button-group slot="visitorProfile" slot-scope="props" size="small" class="d-flex justify-content-center">
            <img class="integration-image ml-1 mr-1" v-if="hasGAIntegration(props.row)" src="@/assets/images/sales-overview/google_analytics.svg" alt="ga">
            <img class="integration-image ml-1 mr-1" v-if="hasBAIntegration(props.row)" src="@/assets/images/microsoft.svg" alt="microsoft">
            <img class="integration-image ml-1 mr-1" v-if="hasFBIntegration(props.row)" src="@/assets/images/facebook.svg" alt="fb">
            <img class="integration-image ml-1 mr-1" v-if="hasTransactionClickID(props.row)" src="@/assets/images/sales-overview/google_ads-icon.svg" alt="ga">
            <img class="integration-image ml-1 mr-1" v-if="hasKickbiteIntegration(props.row)" src="@/assets/images/kickbite-mini.svg" alt="kickbite">
        </d-button-group>
        <table class="table mb-0" slot="child_row" slot-scope="props">
            <tbody>
                <tr>
                    <td class="collapse-td bg-light">Domain</td>
                    <td class="collapse-td">{{ props.row.domain }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Network name</td>
                    <td class="collapse-td">{{ props.row.affiliate_network_human_readable_name }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Click</td>
                    <td class="collapse-td">{{ props.row.date_click, props.row.time_click | toCurrentTime }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Network ID</td>
                    <td class="collapse-td">{{ props.row.unique_id }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Description</td>
                    <td class="collapse-td">{{ props.row.transaction_description }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Transaction</td>
                    <td class="collapse-td">{{ props.row.date_transaction, props.row.time_transaction | toCurrentTime }}</td>
                </tr>
                <tr>
                    <td class="collapse-td bg-light">Sub ID</td>
                    <td class="collapse-td">{{ props.row.sub_id }}</td>
                </tr>
                <tr v-if="hasGAIntegration(props.row)">
                    <td class="collapse-td bg-light">Google Analytics User ID</td>
                    <td class="collapse-td">{{ getTransactionMetaData(props.row).ga.client_id }}</td>
                </tr>
                <tr v-if="hasBAIntegration(props.row)">
                    <td class="collapse-td bg-light">Microsoft Advertising ID</td>
                    <td class="collapse-td">{{ getTransactionMetaData(props.row).ba.click_id }}</td>
                </tr>
                <tr v-if="hasFBIntegration(props.row)">
                    <td class="collapse-td bg-light">FBC</td>
                    <td class="collapse-td">{{ getTransactionMetaData(props.row).fb.fbc }}
                    </td>
                </tr>
                <tr v-if="hasTransactionClickID(props.row)">
                    <td class="collapse-td bg-light">Google Ads visitor ID</td>
                    <td class="collapse-td">{{ getTransactionMetaData(props.row).ga.click_id }}
                    </td>
                </tr>
                <tr v-if="hasKickbiteIntegration(props.row)">
                    <td class="collapse-td bg-light">Kickbite User ID</td>
                    <td class="collapse-td">{{ getTransactionMetaData(props.row).kb.kbuid }}
                    </td>
                </tr>
            </tbody>
        </table>
        <span slot="transaction_status" slot-scope="props" :class="[getStatus(props.row.internal_transaction_status_name), 'text-white']">
            {{ props.row.internal_transaction_status_name }}
        </span>
    </v-client-table>
</template>

<script>
import TransactionStatus from '@/helpers/transactionStatus';
import detectVisitorProfiles from '../../../mixins/detectVisitorProfiles';

export default {

    mixins: [ detectVisitorProfiles ],
    props: ['transactions'],

    data() {
        return {
            columns: ['affiliate_network_name', 'date_transaction', 'program_name', 'domain', 'visitorProfile', 'transaction_status', 'amount'],

            /**
            * Vue Tables Configuration Options
            * @see https://github.com/matfish2/vue-tables-2
            */
            clientTableOptions: {
                perPage: 5,
                pagination: { show: false },
                childRowTogglerFirst: false,
                skin: 'transaction-history table dataTable',
                filterable: false,
                texts: {
                    limit: false,
                    count: ''
                },
                columnsDisplay: {
                    visitorProfile: 'desktop',
                    transaction_status: 'desktop',
                    domain: 'desktop',
                    date_transaction: 'desktop',
                },
                columnsClasses: {
                    date: 'dashboard',
                    advertiser: 'dashboard',
                },
                headings: {
                    affiliate_network_name: '',
                    date_transaction: 'Date',
                    program_name: 'Advertiser',
                    domain: 'Domain',
                    transaction_status: 'Status',
                    visitorProfile: 'Visitor profile',
                },
            },
        };
    },

    methods: {
        getStatus(status) {
            return TransactionStatus.getStatusClass(status);
        },
    },
};
</script>
